(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npGridExporter', [function () {
        return {
            restrict: 'E',
            controller: ['ngDialog', '$scope', controller],
            scope: {
                excelExporterUrl: '@',
                wordExporterUrl: '@',
                exportParams: '=',
                loadExportColumns: '&', // Some views get column settings from local storage, we also need to support this case
                fileName: '@',
                exporterUrl: '@'
            },
            templateUrl: paths.GridExporterControlView,
            replace: true
        }
    }]);

    function controller(ngDialog, $scope) {
        $scope.translation = globalResources;
        $scope.showExporterDialog = showExporterDialog;
        function showExporterDialog() {
            if ($scope.loadExportColumns) {
                $scope.loadExportColumns();
            }

            ngDialog.open({
                template: paths.GridDialogExporterView,
                controller: 'dialogExporter',
                data: {
                    excelExporterUrl: $scope.excelExporterUrl,
                    wordExporterUrl: $scope.wordExporterUrl,
                    exportParams: $scope.exportParams,
                    fileName: $scope.fileName,
                    exporterUrl: $scope.exporterUrl
                },
                className: 'ngdialog-theme-default'
            });
        }
    }
})();